import styled from "styled-components";

export const Container = styled.div`
  height: 60px;
  width: 90%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const SubContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
export const Logo = styled.img`
  width: 40px;
`;
export const Title = styled.h1`
  color: ${({ theme }) => theme.COLORS.TITLE};
  text-align: center;
  font-weight: 400;
  font-size: 16px;
  padding: 0;
  margin: 0;
  
   @media (max-width: 360px) {
         font-size: 12px;
    }
      @media (max-width: 768px) {
                  font-size: 12px;

    }
`;
export const Description = styled.p`
  color: ${({ theme }) => theme.COLORS.DESCRIPTION};
  font-size: 12px;
  font-weight: 500;
  margin: 0;
  text-align: center;
  padding: 10px;

   @media (max-width: 360px) {
         font-size: 8px;
    }
      @media (max-width: 768px) {
          font-size: 8px;
    }
`;